import { Stepper as StepperComponent } from './Stepper'
import { StepperItem } from './StepperItem';

export const Stepper = Object.assign(StepperComponent, {
    Item: StepperItem
})
